import PubSub from "underpub-js";

var TrimSlope = function(options) {

	this.options = {
		$el: false,
		baseClass: 'atom-TrimSlope',
	};

	$.extend(true, this.options, options);

};

TrimSlope.prototype.init = function() {

	var self = this;

};

export default TrimSlope;
